module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_vm._v("设备编号：" + _vm._s(_vm.device.id))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备类型：" + _vm._s(_vm.device.typeName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("剩余次数：" + _vm._s(_vm.device.useNumber) + " 次")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("门店名称：" + _vm._s(_vm.device.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备状态：" + _vm._s(_vm.device.status == 0 ? "离线" : _vm.device.status == 1 ? "在线" : _vm.device.status))]), _vm._v(" "), (_vm.startSuccess) ? _c('div', {
    staticClass: "success"
  }, [_c('el-alert', {
    attrs: {
      "title": "启动成功",
      "description": "设备已成功启动！",
      "type": "success",
      "show-icon": "",
      "closable": false
    }
  })], 1) : _c('div', {
    staticClass: "item center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("启动设备")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d362b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/staff/index.vue
// module id = 1165
// module chunks = 2